import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagAX(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURQ9vqRJ3tBN5t//OOf/RQhR7ud8vM+IxNRV8u+o1Ouc0OI+vEcMAAAFUSURBVDjL7Y+/asMwEIdPbyDlCWKB94BNu6aVQppOwWDQ2MlZM0VrF0NeoX2BQp+yd6c/kZO0gUK3fkTW704fpwiOCbt5s0/Hc15hIqxG5yiPcSfBjWOPOBcmUOVcEChvoY+wsOrPOQm93bzfEJ4/vxN0p3Vdk/DY1fXpsMNqCzoQBdy7LnY0pXkStA7COb8Xqmo2ozUHDgphIeYECRwqhISHVBBqpiolQVHgCWvPQh7BbQl5nF1/hAkTJoL/I8FmULhkeVswxtjW0Pfe2xaxFhu0mCX4w2G38/xNaRhS9n4PvmxNZVp7GAJUlntKL9Bk7oYcTU4LaEzLP2NQMJzapo3JmMX1CU0xIUPCQsAFklEiClOkAhCsoMgCSKoFdSmEEbiEiFdILpMRlBDjFXjO89J/ESnKOKFoSxwrU02T4xXhXJbvEMUzT0eXDy6uuM6/8KPwBd1/8zE806dpAAAAAElFTkSuQmCC",
    alt: "AX"
  }, props));
}